import React, { useState } from 'react';
import { PropsWithChildren, createContext } from "react";


export const RuleContext = createContext<any>(undefined);

export const RuleContextProvider = ({ children }: PropsWithChildren) => {
    const [newId, setNewId] = useState<string>("")
    return (
        <RuleContext.Provider value={{ newId, setNewId }}>
            {children}
        </RuleContext.Provider>
    );
}
